(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-pcb-root]";

  var CATEGORIES = [
    { key: "cpu", handle: "المعالجات", required: true },
    { key: "motherboard", handle: "مذربوردات", required: true },
    { key: "ram", handle: "الرامات", required: true },
    { key: "gpu", handle: "كروت-الشاشة", required: false },
    { key: "cooler", handle: "مبردات", required: false },
    { key: "storage", handle: "مساحات-التخزين", required: false },
    { key: "psu", handle: "باور-سبلاي", required: true },
    { key: "case", handle: "كيسات", required: true }
  ];

  function extractTag(tags, prefix) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].toLowerCase().indexOf(prefix) === 0) return tags[i].slice(prefix.length);
    }
    return null;
  }

  function parseSocket(tags, text) {
    var t = extractTag(tags, "socket:");
    if (t) return t.toUpperCase();
    var m = text.match(/\bAM[3-5]\+?\b/i);
    if (m) return m[0].toUpperCase();
    m = text.match(/\bLGA\s?-?\d{3,4}\b/i);
    if (m) return m[0].replace(/\s+/g, "").toUpperCase();
    return null;
  }

  function parseDDR(tags, text) {
    var t = extractTag(tags, "ddr:");
    if (t) return t.toUpperCase();
    var m = text.match(/\bDDR([45])\b/i);
    if (m) return "DDR" + m[1];
    return null;
  }

  function parseFormFactor(text) {
    if (/mini-?itx/i.test(text)) return "Mini-ITX";
    if (/micro-?atx|m-?atx\b/i.test(text)) return "Micro-ATX";
    if (/e-?atx/i.test(text)) return "E-ATX";
    if (/\batx\b/i.test(text)) return "ATX";
    return null;
  }

  function parseSupportedFormFactors(text) {
    var found = [];
    if (/mini-?itx/i.test(text)) found.push("Mini-ITX");
    if (/micro-?atx|m-?atx\b/i.test(text)) found.push("Micro-ATX");
    if (/e-?atx/i.test(text)) found.push("E-ATX");
    if (/\batx\b/i.test(text)) found.push("ATX");
    return found;
  }

  function parseWattage(text) {
    var m = text.match(/(\d{3,4})\s?w\b/i);
    return m ? parseInt(m[1], 10) : null;
  }

  function gpuTier(text) {
    if (/5090|5080|4090|4080|7900\s?xtx|7900\s?xt/i.test(text)) return "high";
    if (/5070|5060\s?ti|4070|4060\s?ti|7800\s?xt|7700\s?xt/i.test(text)) return "mid";
    return "entry";
  }

  function cpuTier(text) {
    if (/i9|ryzen\s?9|x3d/i.test(text)) return "high";
    if (/i7|ryzen\s?7/i.test(text)) return "mid";
    return "entry";
  }

  function parseCoolerSockets(text) {
    var sockets = [];
    var re = /\bAM[3-5]\+?\b|\bLGA\s?-?\d{3,4}\b/gi;
    var m;
    while ((m = re.exec(text))) sockets.push(m[0].replace(/\s+/g, "").toUpperCase());
    return sockets;
  }

  function isAioCooler(text) {
    return /\baio\b|liquid\s?cool|\b(120|140|240|280|360)\s?mm\b/i.test(text);
  }

  function firstAvailableVariant(product) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available !== false) return product.variants[i];
    }
    return product.variants[0];
  }

  function normalizeProduct(p, categoryKey) {
    var tags = p.tags || [];
    var text = [p.title, (p.body_html || "").replace(/<[^>]+>/g, " ")].join(" ");
    var variant = firstAvailableVariant(p);
    var img = p.images && p.images[0] ? p.images[0].src : (p.featured_image || null);

    var item = {
      id: p.id,
      variantId: variant ? variant.id : null,
      title: p.title,
      price: variant ? parseFloat(variant.price) : parseFloat(p.price || 0),
      available: variant ? variant.available !== false : false,
      image: img,
      handle: p.handle
    };

    if (categoryKey === "cpu") {
      item.socket = parseSocket(tags, text);
      item.tier = cpuTier(text);
    } else if (categoryKey === "motherboard") {
      item.socket = parseSocket(tags, text);
      item.ddr = parseDDR(tags, text);
      item.formFactor = parseFormFactor(text);
    } else if (categoryKey === "ram") {
      item.ddr = parseDDR(tags, text);
    } else if (categoryKey === "case") {
      item.supportedFormFactors = parseSupportedFormFactors(text);
    } else if (categoryKey === "cooler") {
      item.sockets = parseCoolerSockets(text);
      item.isAio = isAioCooler(text);
    } else if (categoryKey === "gpu") {
      item.tier = gpuTier(text);
    } else if (categoryKey === "psu") {
      item.wattage = parseWattage(text);
    }
    return item;
  }

  function fetchCollection(handle) {
    var url = "/collections/" + encodeURIComponent(handle) + "/products.json?limit=250";
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error("failed " + handle);
      return r.json();
    }).then(function (d) { return d.products || []; }).catch(function () { return []; });
  }

  function buildVisualSVG() {
    return (
      '<svg viewBox="0 0 380 480" xmlns="http://www.w3.org/2000/svg">' +
      "<defs>" +
        '<linearGradient id="pcbMetal" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0" stop-color="#332c52"/><stop offset="1" stop-color="#1a1530"/>' +
        "</linearGradient>" +
        '<linearGradient id="pcbGlass" x1="0" y1="0" x2="1" y2="1">' +
          '<stop offset="0" stop-color="#6fd8ff" stop-opacity="0.14"/>' +
          '<stop offset="0.5" stop-color="#7b2ff7" stop-opacity="0.08"/>' +
          '<stop offset="1" stop-color="#101018" stop-opacity="0.35"/>' +
        "</linearGradient>" +
        '<linearGradient id="pcbBoard" x1="0" y1="0" x2="1" y2="1">' +
          '<stop offset="0" stop-color="#1c3b2e"/><stop offset="1" stop-color="#12271f"/>' +
        "</linearGradient>" +
        '<linearGradient id="pcbChrome" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0" stop-color="#eef1f6"/><stop offset="0.5" stop-color="#aeb6c6"/><stop offset="1" stop-color="#7d8494"/>' +
        "</linearGradient>" +
        '<linearGradient id="pcbGpu" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0" stop-color="#26212f"/><stop offset="1" stop-color="#0f0d14"/>' +
        "</linearGradient>" +
      "</defs>" +
      '<rect x="18" y="18" width="344" height="444" rx="20" fill="none" stroke="#3a3358" stroke-width="2" stroke-dasharray="6 6" data-part="case-placeholder"/>' +
      '<g data-part="case-chassis" style="opacity:0;transition:opacity .5s">' +
        '<rect x="14" y="14" width="352" height="452" rx="22" fill="#15111f" stroke="#000" stroke-width="1"/>' +
        '<rect x="14" y="14" width="46" height="452" rx="22" fill="url(#pcbMetal)"/>' +
        '<g fill="#0d0a19" opacity="0.6">' +
          Array.from({length: 10}).map(function(_,i){return '<circle cx="37" cy="'+(50+i*40)+'" r="3"/>';}).join('') +
        "</g>" +
        '<rect x="66" y="30" width="290" height="420" rx="14" fill="url(#pcbGlass)" stroke="#4a4270" stroke-width="1.5"/>' +
        '<path d="M80 40 L140 40 L95 420 L80 420 Z" fill="#ffffff" opacity="0.05"/>' +
        '<rect x="30" y="462" width="30" height="10" rx="4" fill="#0d0a19"/>' +
        '<rect x="320" y="462" width="30" height="10" rx="4" fill="#0d0a19"/>' +
        '<circle cx="37" cy="380" r="14" fill="none" stroke="#5c5482" stroke-width="2"/>' +
        '<circle cx="37" cy="430" r="14" fill="none" stroke="#5c5482" stroke-width="2"/>' +
      "</g>" +
      '<g data-part="motherboard" style="opacity:0;transition:opacity .4s">' +
        '<rect x="95" y="60" width="180" height="345" rx="8" fill="url(#pcbBoard)" stroke="#0a1a13" stroke-width="1.5"/>' +
        Array.from({length:5}).map(function(_,i){return '<line x1="105" y1="'+(80+i*14)+'" x2="180" y2="'+(80+i*14)+'" stroke="#2f5b47" stroke-width="1"/>';}).join('') +
        '<rect x="230" y="70" width="26" height="26" rx="3" fill="#0d0a19" stroke="#3a5c4c"/>' +
      "</g>" +
      '<g data-part="cpu" style="opacity:0;transition:opacity .4s">' +
        '<rect x="130" y="95" width="62" height="62" rx="4" fill="url(#pcbChrome)" stroke="#5c626f" stroke-width="1"/>' +
        '<path d="M130 95 L142 95 L130 107 Z" fill="#d4a93a"/>' +
      "</g>" +
      '<g data-part="cooler-air" style="opacity:0;transition:opacity .4s">' +
        Array.from({length:6}).map(function(_,i){return '<rect x="'+(126+i*11)+'" y="55" width="7" height="70" fill="url(#pcbChrome)" stroke="#5c626f" stroke-width="0.5"/>';}).join('') +
        '<circle cx="161" cy="90" r="24" fill="#1a1530" stroke="#7b2ff7" stroke-width="2"/>' +
        '<circle cx="161" cy="90" r="5" fill="#7b2ff7"/>' +
        Array.from({length:5}).map(function(_,i){var a=i*72*Math.PI/180; var x1=161+8*Math.cos(a), y1=90+8*Math.sin(a), x2=161+20*Math.cos(a+0.8), y2=90+20*Math.sin(a+0.8); return '<line x1="'+x1+'" y1="'+y1+'" x2="'+x2+'" y2="'+y2+'" stroke="#a08fd6" stroke-width="2" stroke-linecap="round"/>';}).join('') +
      "</g>" +
      '<g data-part="cooler-aio" style="opacity:0;transition:opacity .4s">' +
        '<rect x="95" y="34" width="180" height="20" rx="4" fill="#201a38" stroke="#4a4270"/>' +
        Array.from({length:16}).map(function(_,i){return '<line x1="'+(100+i*11)+'" y1="36" x2="'+(100+i*11)+'" y2="52" stroke="#3a3358" stroke-width="1"/>';}).join('') +
        '<path d="M180 54 C160 70, 165 90, 155 100" fill="none" stroke="#7b2ff7" stroke-width="4" stroke-linecap="round"/>' +
        '<path d="M200 54 C195 75, 170 85, 168 105" fill="none" stroke="#7b2ff7" stroke-width="4" stroke-linecap="round"/>' +
        '<circle cx="161" cy="118" r="20" fill="#1a1530" stroke="#7b2ff7" stroke-width="2"/>' +
        '<circle cx="161" cy="118" r="6" fill="#7b2ff7"/>' +
      "</g>" +
      '<g data-part="ram" style="opacity:0;transition:opacity .4s">' +
        '<rect x="240" y="90" width="12" height="110" rx="2" fill="#2a2350" stroke="#7b2ff7" stroke-width="1"/>' +
        '<rect x="240" y="90" width="12" height="6" fill="#ffb020"/>' +
        '<rect x="258" y="90" width="12" height="110" rx="2" fill="#2a2350" stroke="#7b2ff7" stroke-width="1"/>' +
        '<rect x="258" y="90" width="12" height="6" fill="#ffb020"/>' +
      "</g>" +
      '<g data-part="gpu" style="opacity:0;transition:opacity .4s">' +
        '<rect x="100" y="270" width="165" height="58" rx="8" fill="url(#pcbGpu)" stroke="#ff8a3d" stroke-width="1.5"/>' +
        '<rect x="100" y="270" width="165" height="6" fill="#ff5a1f"/>' +
        '<circle cx="140" cy="299" r="16" fill="#0d0a19" stroke="#3a3358" stroke-width="1"/>' +
        '<circle cx="225" cy="299" r="16" fill="#0d0a19" stroke="#3a3358" stroke-width="1"/>' +
        '<rect x="80" y="278" width="20" height="8" fill="#7d8494"/>' +
      "</g>" +
      '<g data-part="storage" style="opacity:0;transition:opacity .4s">' +
        '<rect x="230" y="200" width="45" height="16" rx="3" fill="#251f3d" stroke="#3a3358"/>' +
        '<text x="252" y="211" font-size="7" fill="#a79fc7" text-anchor="middle">SSD</text>' +
      "</g>" +
      '<g data-part="psu" style="opacity:0;transition:opacity .4s">' +
        '<rect x="95" y="345" width="180" height="55" rx="6" fill="#201a38" stroke="#4a4270" stroke-width="1.5"/>' +
        '<circle cx="185" cy="372" r="16" fill="none" stroke="#5c5482" stroke-width="1.5"/>' +
        '<circle cx="185" cy="372" r="10" fill="none" stroke="#5c5482" stroke-width="1"/>' +
        '<path d="M235 380 C260 390, 270 410, 260 430" fill="none" stroke="#0d0a19" stroke-width="5" stroke-linecap="round"/>' +
      "</g>" +
      "</svg>"
    );
  }

  function setPart(root, part, on) {
    var el = root.querySelector('[data-part="' + part + '"]');
    if (el) el.style.opacity = on ? 1 : 0;
  }

  function updateVisual(root, state) {
    var hasCase = !!state.selected.case;
    setPart(root, "case-placeholder", hasCase ? 0 : 1);
    setPart(root, "case-chassis", hasCase ? 1 : 0);
    setPart(root, "motherboard", state.selected.motherboard);
    setPart(root, "cpu", state.selected.cpu);
    var cooler = state.selected.cooler;
    setPart(root, "cooler-air", cooler && !cooler.isAio);
    setPart(root, "cooler-aio", cooler && cooler.isAio);
    setPart(root, "ram", state.selected.ram);
    setPart(root, "gpu", state.selected.gpu);
    setPart(root, "storage", state.selected.storage);
    setPart(root, "psu", state.selected.psu);
  }

  function getCompatibleList(catalog, state, key) {
    var list = catalog[key] || [];
    var mobo = state.selected.motherboard;
    var cpu = state.selected.cpu;

    if (key === "motherboard" && cpu && cpu.socket) {
      list = list.filter(function (p) { return !p.socket || p.socket === cpu.socket; });
    }
    if (key === "ram" && mobo && mobo.ddr) {
      list = list.filter(function (p) { return !p.ddr || p.ddr === mobo.ddr; });
    }
    if (key === "case" && mobo && mobo.formFactor) {
      list = list.filter(function (p) {
        return !p.supportedFormFactors || !p.supportedFormFactors.length || p.supportedFormFactors.indexOf(mobo.formFactor) !== -1;
      });
    }
    if (key === "cooler" && cpu && cpu.socket) {
      list = list.filter(function (p) {
        return !p.sockets || !p.sockets.length || p.sockets.indexOf(cpu.socket) !== -1;
      });
    }
    return list;
  }

  function recommendedWattage(state) {
    var base = 400;
    var gpu = state.selected.gpu, cpu = state.selected.cpu;
    if (gpu) base += gpu.tier === "high" ? 250 : gpu.tier === "mid" ? 100 : 50;
    if (cpu && cpu.tier === "high") base += 50;
    return base;
  }

  function init(root) {
    var i18nEl = root.parentElement.querySelector('[data-pcb-i18n]') || document.querySelector('[data-pcb-i18n]');
    var I18N = {};
    try { I18N = JSON.parse(i18nEl.textContent); } catch (e) { I18N = {}; }
    var lang = I18N.lang === "ar" ? "ar" : "en";

    function fmtMoney(amount) {
      try {
        return new Intl.NumberFormat(lang === "ar" ? "ar" : "en", {
          style: "currency", currency: I18N.currency || "AED", maximumFractionDigits: 0, numberingSystem: "latn"
        }).format(amount);
      } catch (e) { return amount + " " + (I18N.currency || ""); }
    }

    var stepsEl = root.querySelector("[data-pcb-steps]");
    var visualEl = root.querySelector("[data-pcb-visual]");
    var summaryEl = root.querySelector("[data-pcb-summary]");
    var totalEl = root.querySelector("[data-pcb-total]");
    var ctaEl = root.querySelector("[data-pcb-cta]");
    var ctaNoteEl = root.querySelector("[data-pcb-cta-note]");
    var psuWarnEl = root.querySelector("[data-pcb-psu-warning]");

    visualEl.innerHTML = buildVisualSVG();

    var state = { selected: {} };
    var catalog = {};

    stepsEl.innerHTML = '<div class="pcb__loading">' + (I18N.loading || "Loading…") + "</div>";

    Promise.all(CATEGORIES.map(function (c) { return fetchCollection(c.handle); }))
      .then(function (results) {
        CATEGORIES.forEach(function (c, i) {
          catalog[c.key] = results[i].map(function (p) { return normalizeProduct(p, c.key); });
        });
        renderSteps();
        renderSummary();
        updateVisual(root, state);
      });

    function labelFor(key) { return (I18N.categories && I18N.categories[key]) || key; }

    function renderSteps() {
      stepsEl.innerHTML = "";
      CATEGORIES.forEach(function (cat, idx) {
        var list = getCompatibleList(catalog, state, cat.key);
        var stepEl = document.createElement("div");
        stepEl.className = "pcb__step" + (state.selected[cat.key] ? " done" : "");

        var head = document.createElement("div");
        head.className = "pcb__step-head";
        head.innerHTML =
          '<div class="pcb__step-num">' + (idx + 1) + "</div>" +
          '<div class="pcb__step-title">' + labelFor(cat.key) +
          (cat.required ? "" : ' <span class="pcb__badge-optional">' + (I18N.optional || "Optional") + "</span>") +
          "</div>";
        stepEl.appendChild(head);

        var wrap = document.createElement("div");
        wrap.className = "pcb__select-wrap";

        if (!list.length) {
          wrap.className = "";
          var empty = document.createElement("div");
          empty.className = "pcb__empty-msg";
          empty.textContent = I18N.empty || "No compatible parts available.";
          wrap.appendChild(empty);
        } else if (cat.key === "case") {
          wrap.className = "pcb__case-wrap";

          var searchInput = document.createElement("input");
          searchInput.type = "text";
          searchInput.className = "pcb__case-search";
          searchInput.placeholder = I18N.case_search || "Search cases…";
          searchInput.value = state.caseSearch || "";
          wrap.appendChild(searchInput);

          var grid = document.createElement("div");
          grid.className = "pcb__case-grid";
          wrap.appendChild(grid);

          var moreBtn = document.createElement("button");
          moreBtn.type = "button";
          moreBtn.className = "pcb__case-more";

          var VISIBLE_STEP = 8;
          if (typeof state.caseExpanded === "undefined") state.caseExpanded = false;

          var cardEntries = list.map(function (item) {
            var card = document.createElement("button");
            card.type = "button";
            card.className = "pcb__case-card" + (state.selected.case && state.selected.case.id === item.id ? " selected" : "");
            card.disabled = !item.available;
            card.innerHTML =
              (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : "") +
              '<span class="pcb__case-card-check">✓</span>' +
              '<span class="pcb__case-card-title">' + item.title + "</span>" +
              '<span class="pcb__case-card-price">' + fmtMoney(item.price) + "</span>";
            card.addEventListener("click", function () {
              state.selected.case = (state.selected.case && state.selected.case.id === item.id) ? undefined : item;
              if (!state.selected.case) delete state.selected.case;
              renderSteps(); renderSummary(); updateVisual(root, state);
            });
            grid.appendChild(card);
            return { item: item, el: card };
          });

          wrap.appendChild(moreBtn);

          function applyCaseFilter() {
            var q = (state.caseSearch || "").trim().toLowerCase();
            var visible = cardEntries.filter(function (e) { return !q || e.item.title.toLowerCase().indexOf(q) !== -1; });
            var visibleIds = {};
            visible.forEach(function (e) { visibleIds[e.item.id] = true; });
            cardEntries.forEach(function (e) { e.el.style.display = visibleIds[e.item.id] ? "" : "none"; });

            var limit = state.caseExpanded ? visible.length : Math.min(VISIBLE_STEP, visible.length);
            visible.forEach(function (e, i) { if (i >= limit) e.el.style.display = "none"; });

            var remaining = visible.length - limit;
            if (remaining > 0) {
              moreBtn.style.display = "";
              moreBtn.textContent = (I18N.show_more || "Show more") + " (" + remaining + ")";
            } else if (state.caseExpanded && visible.length > VISIBLE_STEP) {
              moreBtn.style.display = "";
              moreBtn.textContent = I18N.show_less || "Show less";
            } else {
              moreBtn.style.display = "none";
            }
          }

          searchInput.addEventListener("input", function () {
            state.caseSearch = this.value;
            state.caseExpanded = false;
            applyCaseFilter();
          });
          moreBtn.addEventListener("click", function () {
            state.caseExpanded = !state.caseExpanded;
            applyCaseFilter();
          });

          applyCaseFilter();
        } else {
          var select = document.createElement("select");
          select.className = "pcb__select";

          var placeholder = document.createElement("option");
          placeholder.value = "";
          placeholder.textContent = (cat.required ? (I18N.select_prefix || "Select") : (I18N.without_prefix || "Without")) + " " + labelFor(cat.key);
          select.appendChild(placeholder);

          list.forEach(function (item) {
            var opt = document.createElement("option");
            opt.value = item.id;
            var extra = (cat.key === "cooler" && (!item.sockets || !item.sockets.length)) ? " ⚠" : "";
            opt.textContent = item.title + " — " + fmtMoney(item.price) + extra;
            if (!item.available) { opt.textContent += " (" + (I18N.out_of_stock || "Out of stock") + ")"; opt.disabled = true; }
            if (state.selected[cat.key] && state.selected[cat.key].id === item.id) opt.selected = true;
            select.appendChild(opt);
          });

          select.addEventListener("change", function () {
            var val = this.value;
            if (!val) delete state.selected[cat.key];
            else state.selected[cat.key] = list.filter(function (p) { return String(p.id) === String(val); })[0];
            clearDownstream(cat.key);
            renderSteps(); renderSummary(); updateVisual(root, state);
          });

          wrap.appendChild(select);

          if (cat.key === "cooler" && list.some(function (p) { return !p.sockets || !p.sockets.length; })) {
            var note = document.createElement("div");
            note.className = "pcb__compat-note";
            note.textContent = I18N.cooler_note || "⚠ Some coolers could not be auto-verified for socket support.";
            wrap.appendChild(note);
          }
        }

        stepEl.appendChild(wrap);
        stepsEl.appendChild(stepEl);
      });
    }

    function clearDownstream(changedKey) {
      if (changedKey === "cpu") {
        ["motherboard", "ram", "case", "cooler"].forEach(function (k) { delete state.selected[k]; });
      }
      if (changedKey === "motherboard") {
        var mobo = state.selected.motherboard;
        if (state.selected.ram && mobo && state.selected.ram.ddr && mobo.ddr && state.selected.ram.ddr !== mobo.ddr) delete state.selected.ram;
        if (state.selected.case && mobo && mobo.formFactor && state.selected.case.supportedFormFactors && state.selected.case.supportedFormFactors.length && state.selected.case.supportedFormFactors.indexOf(mobo.formFactor) === -1) delete state.selected.case;
      }
    }

    function renderSummary() {
      summaryEl.innerHTML = "";
      var total = 0, allRequiredFilled = true;

      CATEGORIES.forEach(function (cat) {
        var sel = state.selected[cat.key];
        if (sel) {
          total += sel.price;
          var row = document.createElement("div");
          row.className = "pcb__summary-row";
          row.innerHTML = '<span class="name">' + labelFor(cat.key) + "</span><span>" + fmtMoney(sel.price) + "</span>";
          summaryEl.appendChild(row);
        }
        if (cat.required && !sel) allRequiredFilled = false;
      });

      totalEl.textContent = fmtMoney(total);

      var psu = state.selected.psu;
      if (psu && psu.wattage) {
        var rec = recommendedWattage(state);
        if (psu.wattage < rec) {
          psuWarnEl.textContent = (I18N.psu_warning || "⚠ Selected PSU ({watt}W) may be lower than recommended ({rec}W+).")
            .replace("{watt}", psu.wattage).replace("{rec}", rec);
          psuWarnEl.classList.add("show");
        } else psuWarnEl.classList.remove("show");
      } else psuWarnEl.classList.remove("show");

      ctaEl.disabled = !allRequiredFilled;
      ctaNoteEl.textContent = allRequiredFilled ? "" : (I18N.incomplete || "Select all required parts to complete your build");
    }

    ctaEl.addEventListener("click", function () {
      var items = [];
      Object.keys(state.selected).forEach(function (k) {
        var sel = state.selected[k];
        if (sel && sel.variantId) items.push({ id: sel.variantId, quantity: 1 });
      });
      if (!items.length) return;

      ctaEl.disabled = true;
      ctaEl.textContent = I18N.adding || "Adding…";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () {
          ctaNoteEl.textContent = I18N.success || "✅ All parts added to your cart!";
          window.location.href = "/cart";
        })
        .catch(function () {
          ctaEl.disabled = false;
          ctaEl.textContent = I18N.cta || "Add build to cart";
          ctaNoteEl.textContent = I18N.error || "Something went wrong, please try again.";
        });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  });
})();
